var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"linkArea"},[_c('p',{staticClass:"edition"},[_vm._v("\n      版本號："+_vm._s(_vm.version)+"\n    ")])]),_c('div',{staticClass:"copyRight"},[_vm._v("\n    今網智慧科技股份有限公司版權所有 © 2016 Kingnet Corp. All Rights Reserved. Design by Kingnet.\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }